import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import EmailIcon from "@mui/icons-material/Email";
import { useTheme } from "@mui/material/styles";

export default function HelpZone() {
  const theme = useTheme();
  return (
    <>
      <Typography variant="h2">
        Chcę skonsultować się w trudnej sprawie
      </Typography>
      <Typography variant="body1">
        Kiedy w Twoim środowisku dzieje się coś trudnego i nie wiesz jak na to
        zareagować, wybierz najszybszą drogę uzyskania wsparcia. Zespół
        psychologów Strefy Pomocy ZHP czeka na telefony w dni powszednie od 15
        do 21 pod numerem telefonu{" "}
        <Link to="tel:+48669116116">+48 669 116 116</Link>. Jeśli sprawa jest
        bardzo pilna, a do dyżuru jeszcze daleko, napisz do nas maila na
        adres&nbsp;
        <Link to="mailto:strefapomocy@zhp.pl">strefapomocy@zhp.pl</Link>–
        postaramy się oddzwonić najszybciej jak to możliwe.
      </Typography>
      <Typography variant="body1">
        Krzywda nie zawsze wiąże się z przekroczeniem granic czy przemocą,
        czasem czyjeś zdrowie lub bezpieczeństwo wynika z choroby,
        nieporozumienia lub uwarunkowań społecznych, a to nie wymaga zgłoszenia
        w Centralnym Systemie Zgłoszeń. Kiedy obawiasz się o czyjeś zdrowie albo
        bezpieczeństwo często potrzebne są szybkie i skuteczne działania
        ochronne, a ciebie – jako osobę, która widzi ich potrzebę, kosztuje to
        dużo emocji (wiążących się m.in. z poczuciem odpowiedzialności czy
        niepewności co do swoich umiejętności i planowanych działań). Rozmowa na
        ten temat z ekspertem pomoże Ci upewnić się co do kierunku postępowania,
        podzielić z kimś ciężarem tej sytuacji i zaplanować jak
        najbezpieczniejszą formę wsparcia. Jeśli w trakcie rozmowy okaże się, że
        jednak w danej sytuacji dochodzi do przekroczenia granic bądź przemocy
        dyżurujący psycholog pomoże Ci przygotować zgłoszenie.
      </Typography>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        sx={{ textAlign: "center", my: 4 }}
      >
        <PhoneIphoneIcon
          sx={{
            fontSize: {
              xs: theme.typography.h1.fontSize,
              sm: theme.typography.h1["@media (min-width:600px)"].fontSize,
              md: theme.typography.h1["@media (min-width:900px)"].fontSize,
            },
            color: "#86a315",
          }}
        />

        <Typography
          variant="h1"
          component={Link}
          to="tel:+48669116116"
          underline="hover"
          color="#86a315"
          sx={{
            display: "flex",
            alignItems: "center", // 👈 to wyrównuje zawartość w pionie
            lineHeight: 1, // 👈 niweluje nadmiar przestrzeni
            m: 0, // 👈 usuwa marginesy h1 (jeśli są z theme)
          }}
        >
          +48 669 116 116
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        sx={{ textAlign: "center", my: 4 }}
      >
        <EmailIcon
          sx={{
            fontSize: {
              xs: theme.typography.h1.fontSize,
              sm: theme.typography.h1["@media (min-width:600px)"].fontSize,
              md: theme.typography.h1["@media (min-width:900px)"].fontSize,
            },
            color: "#86a315",
          }}
        />

        <Typography
          variant="h1"
          component={Link}
          to="mailto:strefapomocy@zhp.pl"
          underline="hover"
          color="#86a315"
          sx={{
            display: "flex",
            alignItems: "center",
            lineHeight: 1,
            m: 0,
          }}
        >
          strefapomocy@zhp.pl
        </Typography>
      </Box>
    </>
  );
}
